import {Vue} from "ui.vue";

/**
 * Класс конструктор для инициализации компонента
 */
class CitrusComponentInit {
	/**
	 */
	constructor() {
		this.params = null;
		this.vueComponent = null;
		this.signedParameters = null;
		this.componentName = null;
	}

	/**
	 * Динамическое создание компонента
	 * @returns {Init}
	 */
	create(component, params) {
		let obComponentInit = new CitrusComponentInit;

		obComponentInit.params =  Object.assign({}, params);
		obComponentInit.vueComponent = Object.assign({}, component);
		obComponentInit.setParams();

		return Vue.createApp(obComponentInit.vueComponent);
	}

	/**
	 * Фиксируем параметры компонента
	 * @param params
	 */
	setSignedParameters(params) {
		this.signedParameters = params;
		return this;
	}

	/**
	 * Получаем параметры компонента
	 * @return params
	 */
	getSignedParameters() {
		return this.signedParameters;
	}

	/**
	 * Установка параметра компанента
	 */
	setParams() {
		this.vueComponent.el = '#' + this.params.templateId;

		let vueData = this.vueComponent.data();
		let newData = Object.assign({}, vueData, this.params);

		this.vueComponent.data = function() {
			return newData;
		};
		return this;
	}
}

let InitComponent;
InitComponent = new CitrusComponentInit();
export {InitComponent};
